import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NavigationComponent } from './components/navigation/navigation.component';
import { RouterModule } from '@angular/router';
import { BackgroundComponent } from './components/background/background.component';
import { DayCounterComponent } from './components/day-counter/day-counter.component';
import { MissionCardDetailComponent } from './components/mission-card-detail/mission-card-detail.component';
import { MissionCardComponent } from './components/mission-card/mission-card.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { FormsModule } from '@angular/forms';
import { HumanTextCloudComponent } from './components/human-text-cloud/human-text-cloud.component';
import { SafeUrlPipe } from './pipes/SafeUrlPipe';
import { SafeHtmlPipe } from './pipes/SafeHtml';
import { MarkedPipe } from './pipes/MarkedPipe';

@NgModule({
  declarations: [
    NavigationComponent,
    BackgroundComponent,
    DayCounterComponent,
    MissionCardDetailComponent,
    MissionCardComponent,
    DatePickerComponent,
    HumanTextCloudComponent,
    SafeUrlPipe,
    SafeHtmlPipe,
    MarkedPipe,
  ],
  imports: [CommonModule, IonicModule, RouterModule, FormsModule],
  exports: [
    NavigationComponent,
    BackgroundComponent,
    DayCounterComponent,
    MissionCardDetailComponent,
    MissionCardComponent,
    DatePickerComponent,
    HumanTextCloudComponent,
    MarkedPipe,
  ],
})
export class CoreModule {}
